import { resolveDateFilterRange } from "./datePresets";
import { GlobalFilterConfig, GlobalFilterValues } from "./types";

type BuildWidgetFilterParams = {
    fixedFilter?: any;
    respondsTo?: Array<string>;
    globalFilters: Array<GlobalFilterConfig>;
    globalValues: GlobalFilterValues;
    localClauses?: Record<string, any>;
    now: Date;
};

export const buildWidgetFilter = ({ fixedFilter, respondsTo, globalFilters, globalValues, localClauses, now }: BuildWidgetFilterParams) => {
    const clausesByField: Record<string, any> = {};

    const subscribedFilters = globalFilters.filter((globalFilter) => respondsTo?.includes(globalFilter.key));

    subscribedFilters.forEach((globalFilter) => {
        const value = globalValues[globalFilter.key];
        if (value === null || value === undefined || value === "") return;

        if (globalFilter.type === "datePreset") {
            // sem_periodo / personalizado incompleto → sem cláusula (nunca fallback silencioso).
            const range = resolveDateFilterRange(globalValues, globalFilter.key, now);
            if (range) clausesByField[globalFilter.field] = { _gte: range.gte, _lt: range.lt };
        } else if (globalFilter.type === "select") {
            clausesByField[globalFilter.field] = { _eq: value };
        }
        // "choice": filtro client-side (ex.: ativos/suspensos) — nunca produz cláusula de query.
    });

    Object.entries(localClauses || {}).forEach(([field, clause]) => {
        if (clause === null || clause === undefined) {
            delete clausesByField[field];
            return;
        }
        clausesByField[field] = clause;
    });

    const fieldClauses = Object.entries(clausesByField).map(([field, clause]) => ({ [field]: clause }));
    const allClauses = [...(fixedFilter ? [fixedFilter] : []), ...fieldClauses];

    if (allClauses.length === 0) return undefined;

    const combinedFilter = { _and: allClauses };
    return combinedFilter;
};
